/* LUFFKA - product page reviews (the AG Product Reviews "review list" block,
   #AirReviews-BlockWrapper). The app draws the list in the browser and
   redraws it on every page change; this script only adds to what it draws,
   so without it (or if the app renames its classes) the list keeps the
   app's own look.

   1. Shop replies fold under a "Luffka replied" toggle.
   2. "Customers' photos": a strip above the list, from this product's photo
      reviews (best rated first, duplicates dropped). A photo opens in a
      lightbox with that review's words. Fetched from the same service the
      widget uses; if it cannot be reached, or there are no photos, nothing
      is added.
   3. Arrival, played once: stars fill, bars grow, the count ticks up, rows
      settle in. A page change fades the list and returns to its top.
      Reduced motion: no arrival states at all.
   4. Any link to #AirReviews-BlockWrapper glides there.

   Config: #lfk-rv-config (layout/theme.liquid), { shopId, productId }.
   Look: assets/luffka.css (PRODUCT PAGE REVIEWS). */
(function () {
  const WRAP = '#AirReviews-BlockWrapper';
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  let config = {};
  try { config = JSON.parse(document.getElementById('lfk-rv-config').textContent); } catch (e) { /* no strip */ }

  const esc = (s) => String(s).replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));

  /* ---------- 4. links glide to the list ---------- */
  document.addEventListener('click', (e) => {
    const a = e.target.closest('a[href="#AirReviews-BlockWrapper"]');
    const wrap = document.querySelector(WRAP);
    if (!a || !wrap) return;
    e.preventDefault();
    wrap.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
  });

  /* ---------- 1. folded replies ---------- */
  let uid = 0;
  function foldReplies(wrap) {
    // Checked by the button itself, not a marker: when the app redraws it can
    // drop the button but keep the reply element (and anything set on it).
    wrap.querySelectorAll('.AirReviews-Blocks__ShopReply').forEach((reply) => {
      const prev = reply.previousElementSibling;
      if (prev && prev.classList.contains('lfk-rv-reply-btn')) {
        if (!reply.classList.contains('lfk-rv-reply')) reply.classList.add('lfk-rv-reply');
        return;
      }
      const id = 'lfk-rv-reply-' + (++uid);
      reply.id = id;
      reply.classList.add('lfk-rv-reply');
      reply.classList.remove('is-open');
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'lfk-rv-reply-btn';
      btn.setAttribute('aria-expanded', 'false');
      btn.setAttribute('aria-controls', id);
      btn.innerHTML = '<span>Luffka replied</span><svg viewBox="0 0 10 10" aria-hidden="true"><path d="M3 1.5 6.5 5 3 8.5" fill="none" stroke="currentColor" stroke-width="1.4"/></svg>';
      btn.addEventListener('click', () => {
        const open = btn.getAttribute('aria-expanded') !== 'true';
        btn.setAttribute('aria-expanded', String(open));
        reply.classList.toggle('is-open', open);
      });
      reply.before(btn);
    });
  }

  /* ---------- 2. photo strip + lightbox ---------- */
  let photos = null; // [{ src, name, date, text, rate }]
  async function loadPhotos() {
    if (!config.shopId || !config.productId) return [];
    const url = 'https://app.airreviews.io/review/loadReviews?shopId=' + encodeURIComponent(config.shopId) +
      '&productId=' + encodeURIComponent(config.productId) +
      '&sort=rate_desc&minimumRating=all-reviews&from=review_box_widget&limitPerPage=200';
    try {
      const res = await fetch(url);
      if (!res.ok) return [];
      const data = (await res.json()).data || {};
      const list = Array.isArray(data.reviews) ? data.reviews : [];
      const seenImg = new Set();
      const seenText = new Set();
      const out = [];
      list
        .filter((r) => Array.isArray(r.images) && r.images.length)
        .sort((a, b) => (b.rate || 0) - (a.rate || 0))
        .forEach((r) => {
          const text = (r.content || '').trim();
          // The same review imported twice under two names: keep the first.
          if (text && seenText.has(text)) return;
          if (text) seenText.add(text);
          r.images.forEach((src) => {
            if (typeof src !== 'string' || seenImg.has(src)) return;
            seenImg.add(src);
            out.push({ src, name: r.firstName || '', date: (r.createdAt || '').slice(0, 10), text, rate: r.rate || 5 });
          });
        });
      return out;
    } catch (e) {
      return [];
    }
  }

  // Photos are used at their own size: the host's resize suffixes are
  // inconsistent (_480x480 fails in browsers, measured), and review photos
  // are small already.
  const sized = (src) => src;
  const shortName = (n) => { const p = n.trim().split(/\s+/); return p.length > 1 ? p[0] + ' ' + p[p.length - 1][0] + '.' : n; };
  const niceDate = (iso) => { const d = new Date(iso); return isNaN(d) ? '' : d.toLocaleDateString(undefined, { day: 'numeric', month: 'short', year: 'numeric' }); };

  let lightbox;
  function openLightbox(p, from) {
    if (!lightbox) {
      lightbox = document.createElement('div');
      lightbox.className = 'lfk-rv-lb';
      lightbox.hidden = true;
      lightbox.innerHTML = '<div class="lfk-rv-lb__card" role="dialog" aria-modal="true" aria-label="Customer photo">' +
        '<button type="button" class="lfk-rv-lb__x" aria-label="Close">&times;</button>' +
        '<span class="lfk-rv-lb__media"></span>' +
        '<div class="lfk-rv-lb__text"><span class="lfk-rv-lb__stars" aria-hidden="true"></span><p></p><small></small></div></div>';
      document.body.appendChild(lightbox);
      const close = () => { lightbox.hidden = true; document.documentElement.classList.remove('lfk-rv-lb-open'); if (lightbox._from) lightbox._from.focus(); };
      lightbox.querySelector('.lfk-rv-lb__x').addEventListener('click', close);
      lightbox.addEventListener('click', (e) => { if (e.target === lightbox) close(); });
      document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && !lightbox.hidden) close(); });
    }
    lightbox._from = from;
    lightbox.querySelector('.lfk-rv-lb__media').innerHTML = '<img class="lfk-rv-lb__img" src="' + esc(sized(p.src, 960)) + '" alt="Photo from ' + esc(shortName(p.name)) + '’s review">';
    lightbox.querySelector('.lfk-rv-lb__stars').textContent = '★'.repeat(Math.round(p.rate));
    lightbox.querySelector('p').textContent = p.text;
    lightbox.querySelector('p').hidden = !p.text;
    lightbox.querySelector('small').textContent = [shortName(p.name), niceDate(p.date)].filter(Boolean).join(' · ');
    lightbox.hidden = false;
    document.documentElement.classList.add('lfk-rv-lb-open');
    lightbox.querySelector('.lfk-rv-lb__x').focus();
  }

  function placeStrip(wrap) {
    if (!photos || !photos.length || wrap.querySelector('.lfk-rv-strip')) return;
    const list = wrap.querySelector('.AirReviews-Blocks__ListReview');
    if (!list) return;
    const strip = document.createElement('div');
    strip.className = 'lfk-rv-strip';
    strip.innerHTML = '<p class="lfk-rv-strip__label">Customers’ photos</p><div class="lfk-rv-strip__row">' +
      photos.slice(0, 20).map((p, i) => '<button type="button" data-i="' + i + '" aria-label="Photo from ' + esc(shortName(p.name)) + '’s review"><img src="' + esc(sized(p.src, 480)) + '" alt="" loading="lazy" width="240" height="320"></button>').join('') +
      '</div>';
    strip.addEventListener('click', (e) => {
      const b = e.target.closest('button[data-i]');
      if (b) openLightbox(photos[Number(b.dataset.i)], b);
    });
    // Above the sort and page controls, so it reads as part of the summary of the list.
    const sort = wrap.querySelector('.AirReviews-Blocks__ListSort');
    (sort || list).before(strip);
  }

  /* ---------- 3. arrival ---------- */
  let io;
  function arrive(el, onShow) {
    if (reduce || el.hasAttribute('data-lfk-rv-seen')) return;
    el.setAttribute('data-lfk-rv-seen', '');
    if (el.getBoundingClientRect().top < window.innerHeight * 0.9) return; // already on screen: leave it be
    el.classList.add('lfk-rv-pre');
    el._lfkShow = onShow;
    io ??= new IntersectionObserver((entries) => entries.forEach((en) => {
      if (!en.isIntersecting) return;
      io.unobserve(en.target);
      requestAnimationFrame(() => en.target.classList.remove('lfk-rv-pre'));
      if (en.target._lfkShow) en.target._lfkShow();
    }), { rootMargin: '0px 0px -10% 0px' });
    io.observe(el);
  }

  function countUp(el) {
    const to = parseInt(el.textContent.replace(/\D/g, ''), 10);
    if (!to) return;
    const t0 = performance.now();
    const step = (t) => {
      const p = Math.min(1, (t - t0) / 900);
      el.textContent = String(Math.round(to * (1 - Math.pow(1 - p, 3))));
      if (p < 1) requestAnimationFrame(step);
    };
    el.textContent = '0';
    requestAnimationFrame(step);
  }

  function arrivals(wrap) {
    const summary = wrap.querySelector('.AirReviews-Blocks__SummaryInner');
    if (summary) {
      summary.querySelectorAll('.AirReviews-Blocks-ProcessBar').forEach((b, i) => b.style.setProperty('--lfk-i', i));
      const count = summary.querySelector('.AirReviews-Blocks--ReviewCount');
      const num = count && [...count.childNodes].find((n) => /\d/.test(n.textContent || ''));
      arrive(summary, () => { if (num) countUp(num.nodeType === 3 ? num.parentNode : num); });
    }
    wrap.querySelectorAll('.AirReviews-Blocks__ReviewDetails').forEach((row, i) => {
      row.style.setProperty('--lfk-d', (i % 3) * 70 + 'ms');
      arrive(row);
    });
    const strip = wrap.querySelector('.lfk-rv-strip');
    if (strip) arrive(strip);
  }

  /* A page change (the app's pagination or sort): fade the list back in
     and, if its top has scrolled away, return to it. */
  let paging = false;
  function onPaging(wrap) {
    wrap.addEventListener('click', (e) => {
      if (!e.target.closest('.AirReviews-Pagination__button, .AirReviews-Select')) return;
      paging = true;
    }, true);
  }
  function afterPaging(wrap) {
    if (!paging) return;
    paging = false;
    const list = wrap.querySelector('.AirReviews-Blocks__ListReview');
    if (list && !reduce) {
      list.classList.add('lfk-rv-fade');
      requestAnimationFrame(() => requestAnimationFrame(() => list.classList.remove('lfk-rv-fade')));
    }
    const top = (wrap.querySelector('.lfk-rv-strip') || wrap.querySelector('.AirReviews-Blocks__List') || wrap).getBoundingClientRect().top;
    if (top < 0) (wrap.querySelector('.AirReviews-Blocks__List') || wrap).scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
  }

  /* ---------- wiring ---------- */
  function enhance(wrap) {
    if (!wrap.querySelector('.AirReviews-Blocks__ListReview')) return; // not drawn yet, or renamed
    // The app clips its grid (overflow: hidden !important in its own
    // stylesheet, plus an inline overflow), which makes the grid the box the
    // sticky summary sticks to, so the summary would never follow the
    // reader. Only an inline !important outranks the app's !important
    // (measured 2026-10-25); luffka.css itself stays free of !important.
    const grid = wrap.querySelector('.AirReviews-Blocks__LayoutList');
    if (grid && getComputedStyle(grid).overflowY !== 'visible') grid.style.setProperty('overflow', 'visible', 'important');
    foldReplies(wrap);
    placeStrip(wrap);
    arrivals(wrap);
    afterPaging(wrap);
    wrap.setAttribute('data-lfk-rv-ready', '');
  }

  function init() {
    // The app creates its wrapper itself, after this script has run: wait
    // for it rather than give up.
    const wrap = document.querySelector(WRAP);
    if (!wrap) {
      const wait = new MutationObserver(() => {
        if (!document.querySelector(WRAP)) return;
        wait.disconnect();
        init();
      });
      wait.observe(document.body, { childList: true, subtree: true });
      return;
    }
    onPaging(wrap);
    let queued = false;
    const run = () => { queued = false; enhance(wrap); };
    new MutationObserver(() => { if (!queued) { queued = true; requestAnimationFrame(run); } })
      .observe(wrap, { childList: true, subtree: true });
    run();
    loadPhotos().then((p) => { photos = p; enhance(wrap); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
